export enum InterestRateType {
  FIXED = 'Fixed',
  FLOATING = 'Floating',
}
